import Skeleton from '@components/skeleton'
import {
    TechnologiesSkeletonContent,
    SearchSection,
    Search,
    TableSection,
    TableHeader,
    TableHeaderCell,
    TableRow,
    TableCell,
    CellContent,
} from './TechnologiesSkeleton.styles'

const TechnologiesSkeleton = () => {
    return (
        <Skeleton>
            <TechnologiesSkeletonContent>
                <SearchSection>
                    <Search />
                </SearchSection>
                <TableSection>
                    <TableHeader>
                        <TableHeaderCell />
                        <TableHeaderCell />
                        <TableHeaderCell />
                    </TableHeader>
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                        <TableRow key={i}>
                            <TableCell>
                                <CellContent />
                            </TableCell>
                            <TableCell>
                                <CellContent />
                            </TableCell>
                            <TableCell>
                                <CellContent />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableSection>
            </TechnologiesSkeletonContent>
        </Skeleton>
    )
}

export default TechnologiesSkeleton
